import React from 'react';
import '../Assets/css/Grupo.css'; // Ensure the CSS path matches your project structure
export const GrupoPluss = () => {
    return (
        <div className="group-pluss">
            <div className="group-container">
                <div className="group-text">
                    <h1>Respaldo del
                        Grupo Pluss Chile</h1>

                    <p>Travel Pluss fue creada para satisfacer las necesidades
                        de los servicios de transporte exclusivo garantizando
                        siempre el cumplimiento de nuestros pilares
                        fundamentales en cada kilómetro recorrido.</p>

                    <p>Perteneciente al Grupo Pluss Chile, que desde hace ocho
                        años ha sido pionera y ha marcado un hito como
                        referentes en el mercado a nivel nacional. Irrumpimos en
                        el transporte interurbano de pasajeros y en el transporte
                        privado en la gran minería con una nueva experiencia de
                        viaje, donde la comodidad, seguridad, entretenimiento y
                        servicio abordo se han convertido es nuestros pilares.</p>
                </div>
            </div>
        </div>
    )
}